// Swiper is imported already

if (!customElements.get('product-detail-swiper')) {
  class ProductDetailSwiper extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-product-detail-swiper]');

      this.swiperOptions = {
        direction: 'horizontal',
      };

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
      Fancybox.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'image-zoom',
      });
    }
  }

  customElements.define('product-detail-swiper', ProductDetailSwiper);
}

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productFormsQuantity = this.querySelectorAll('product-form input[name="quantity"]');
      this.quantityInputElements = this.querySelectorAll('quantity-input input[name="quantity"]');
      this.quantityInputElements?.forEach((element) =>
        element.addEventListener('change', (event) => {
          this.handleQuantityInput(event);
        })
      );
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput(event) {
      const newValue = event.target?.value;
      if (!newValue) return;

      this.productFormsQuantity.forEach((input) => (input.value = newValue));
      this.quantityInputElements.forEach((input) => (input.value = newValue));
    }
  }
  customElements.define('product-info', ProductInfo);
}
